/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyUpdateGpsRequestDTO
 */
export interface SurveyUpdateGpsRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveyUpdateGpsRequestDTO
     */
    gps: string;
}

export function SurveyUpdateGpsRequestDTOFromJSON(json: any): SurveyUpdateGpsRequestDTO {
    return SurveyUpdateGpsRequestDTOFromJSONTyped(json, false);
}

export function SurveyUpdateGpsRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyUpdateGpsRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gps': json['gps'],
    };
}

export function SurveyUpdateGpsRequestDTOToJSON(value?: SurveyUpdateGpsRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gps': value.gps,
    };
}

